import { string } from 'prop-types';
import React from 'react';
import Moment from 'react-moment';

import { UI_DATE_FORMAT } from '../../utils/constants';

const relativeTimeLimit = 3 * 24 * 60 * 60 * 1000; /* 3 days */
const format = `${UI_DATE_FORMAT} LT`;
const titleFormat = `${UI_DATE_FORMAT} LTS`;
export default function TimeStamp({ children }) {
  return (
    <Moment
      format={format}
      fromNowDuring={relativeTimeLimit}
      withTitle
      titleFormat={titleFormat}
    >
      {children}
    </Moment>
  );
}

TimeStamp.propTypes = {
  children: string.isRequired,
};
